export function downloadImage(data: string, filename: string): void {
    // 创建一个虚拟的链接元素
    const link = document.createElement('a');
    link.href = data;

    // 如果是 base64 编码的图片数据
    if (data.startsWith('data:image')) {
        link.download = filename || 'image.png';
    } else {
        // 如果是图片链接
        link.download = filename || data.split('/').pop() || 'image.png';
    }

    // 将链接元素添加到 DOM 中
    document.body.appendChild(link);

    // 模拟点击链接，触发下载
    link.click();

    // 从 DOM 中移除链接元素
    document.body.removeChild(link);
}

// 例子1：下载 base64 编码的图片
// const base64Data = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAA...'; // 替换为实际的 base64 数据
// downloadImage(base64Data, 'downloaded_image.png');

// 例子2：下载图片链接
// const imageUrl = 'https://example.com/image.jpg'; // 替换为实际的图片链接
// downloadImage(imageUrl, 'downloaded_image.jpg');
